import { domHelpers } from '@approvalmax/utils';
import { Cin7Logo } from 'modules/sprites';
import { FC, memo } from 'react';

import { AmountInfo } from '../../../components/AmountInfo/AmountInfo';
import FieldsSection from '../../../components/FieldsSection';
import { dearRequestFooterQa } from './DearRequestFooter.constants';
import { messages } from './DearRequestFooter.messages';
import { Footer, OpenInOriginLinkText, OperInOriginLink, StyledExchangeRate } from './DearRequestFooter.styles';
import { DearRequestFooterProps } from './DearRequestFooter.types';

export const DearRequestFooter: FC<DearRequestFooterProps> = memo((props) => {
    const { request } = props;
    const details = request.details;

    return (
        <FieldsSection>
            <Footer>
                <div>
                    <StyledExchangeRate request={request} />

                    {details.url && (
                        <OperInOriginLink
                            target='_blank'
                            rel='noopener noreferrer'
                            href={details.url}
                            data-qa={domHelpers.generateDataQa(dearRequestFooterQa, 'external-url-link')}
                        >
                            <Cin7Logo width={30} height={30} />

                            <OpenInOriginLinkText>{messages.openInOriginLinkText}</OpenInOriginLinkText>
                        </OperInOriginLink>
                    )}
                </div>

                <div>
                    <AmountInfo
                        qa={dearRequestFooterQa}
                        netAmount={details.netAmount}
                        taxAmount={details.taxAmount}
                        totalAmount={details.totalAmount}
                        currency={request.currency}
                    />
                </div>
            </Footer>
        </FieldsSection>
    );
});

DearRequestFooter.displayName = 'DearRequestFooter';
